import externalService from '../service/external';

export default function viaplay({ country, language, config = {} }) {
  if (!country || !language) throw new Error('Required parameters not defined.');

  return externalService.getViaplayLiveFeed(country, language, config.onlyHighlights);
}



// WEBPACK FOOTER //
// ./src/provider/viaplay.js